module.exports = __webpack_public_path__ + "static/media/Book-MDV-1.ae9c2113.jpg";